import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, AlertTriangle, ShieldCheck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState('loading'); // loading | ok | err
  const [err, setErr] = useState('');

  useEffect(() => {
    document.title = 'Verifica email — AeroDeals';
    axios.get(`${API}/auth/verify-email/${token}`)
      .then(() => setState('ok'))
      .catch(e => { setErr(e.response?.data?.detail || 'Errore'); setState('err'); });
  }, [token]);

  return (
    <div className="min-h-screen bg-[#09090B] pt-24 flex items-center justify-center px-4" data-testid="verify-email-page">
      <div className="max-w-md w-full text-center">
        {state === 'loading' && (
          <p className="text-zinc-500 text-sm">Verifica in corso...</p>
        )}
        {state === 'ok' && (
          <>
            <ShieldCheck size={48} className="text-emerald-400 mx-auto mb-4" />
            <h1 className="text-2xl md:text-3xl tracking-tight font-medium text-white mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
              Email verificata
            </h1>
            <p className="text-sm text-zinc-500 mb-6 leading-relaxed">Il tuo indirizzo email è stato confermato con successo. Ora puoi usare tutte le funzionalità di AeroDeals in sicurezza.</p>
            <button onClick={() => navigate('/dashboard')} className="bg-[#C5A059] text-black px-5 py-2.5 text-xs font-medium hover:bg-[#D4B271] transition-colors" data-testid="verify-goto-dash">
              Vai alla Dashboard
            </button>
          </>
        )}
        {state === 'err' && (
          <>
            <AlertTriangle size={40} className="text-[#C5A059] mx-auto mb-4 opacity-70" />
            <h1 className="text-2xl md:text-3xl tracking-tight font-medium text-white mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
              Link non valido
            </h1>
            <p className="text-sm text-zinc-500 mb-6 leading-relaxed">{err}. Richiedi un nuovo link dalla pagina Impostazioni.</p>
            <button onClick={() => navigate('/settings')} className="bg-[#C5A059] text-black px-5 py-2.5 text-xs font-medium hover:bg-[#D4B271] transition-colors" data-testid="verify-goto-settings">
              Apri Impostazioni
            </button>
          </>
        )}
      </div>
    </div>
  );
}
